import React from "react"
import "./styles.scss"

export const ContainerLayout = ({ containerClass, children }) => {
  return <div className={containerClass || "container-layout"}>{children}</div>
}

export const Row = ({ children, className }) => {
  return <div className={`row${className ? " " + className : ""}`}>{children}</div>
}

export const Content = ({ children, className }) => {
  return <div className={`content${className ? " " + className : ""}`}>{children}</div>

}

export const ContentArea = ({
  direction,
  children,
  noPadding,
  justifyContent = "initial",
  className,
}) => {
  const padding = noPadding && "0"
  return (
    <div
      className={`${className ? `content-area ${className}` : "content-area"}`}
      style={{ flexDirection: direction, padding: padding, justifyContent: justifyContent }}>
      {children}
    </div>
  )
}

export const Column = ({ children, className }) => {
  return <div className={`${className ? "" + className : "col-auto"}`}>{children}</div>
}

export const GridCardCompany = ({ children, gridClass }) => {
  return <div className={gridClass || "grid-card-company"}>{children}</div>
}

export const ColumnTitle = ({ title }) => {
  return <h2 className="column-title">{title}</h2>
}

export const ColumnArea = ({ children, direction }) => {
  return (
    <div className="column-area" style={{ flexDirection: direction }}>
      {children}
    </div>
  )
}
